export default {
  A: '#e9ccb1',
  a: '#e9ccb1',
  B: '#d3c4b3',
  b: '#d3c4b3',
  C: '#d3c4be',
  c: '#d3c4be',
  D: '#e4dac3',
  d: '#e4dac3',
  E: '#ebcfc4',
  e: '#ebcfc4',
  F: '#ebcfc4',
  f: '#ebcfc4',
  G: '#999999',
  g: '#999999',
  H: '#9eb3bf',
  h: '#9eb3bf',
  I: '#9fc7a1',
  i: '#9fc7a1',
  J: '#D3C4BE',
  j: '#D3C4BE',
  K: '#BBA6A7',
  k: '#BBA6A7',
  L: '#A79993',
  l: '#A79993',
  M: '#BACCB6',
  m: '#BACCB6',
  N: '#9da59f',
  n: '#9da59f',
  O: '#AB919E',
  o: '#AB919E',
  P: '#9B9CB7',
  p: '#9B9CB7',
  Q: '#B6B595',
  q: '#B6B595',
  R: '#868290',
  r: '#868290',
  S: '#e9ccb1',
  s: '#e9ccb1',
  T: '#d3c4b3',
  t: '#d3c4b3',
  U: '#d3c4be',
  u: '#d3c4be',
  V: '#999999',
  v: '#999999',
  W: '#9eb3bf',
  w: '#9eb3bf',
  X: '#9fc7a1',
  x: '#9fc7a1',
  Y: '#BACCB6',
  y: '#BACCB6',
  Z: '#AB919E',
  z: '#AB919E',
  '1': '#9B9CB7',
  '2': '#B6B595',
  '3': '#9fc7a1',
  '4': '#9da59f',
  '5': '#D3C4BE',
  '6': '#BACCB6',
  '7': '#d3c4be',
  '8': '#9eb3bf',
  '9': '#AB919E',
  '0': '#e4dac3'
}
